import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";

import HangupIcon from "@ht/shared/fonts/deos-pis/call-hangup";
import ChatIcon from "@ht/shared/fonts/deos-pis/chat";
import UnmuteIcon from "@ht/shared/fonts/deos-pis/mic";
import MuteIcon from "@ht/shared/fonts/deos-pis/mute";

import { ICallState, IIncomingMessage } from "../../../../app/call/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { callIncomingMessageReceived, callSendMessage, callStateChanged } from "../../../../app/call/callSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";
import { useDragging } from "../../../../hooks/useDragging";
import AudioAnalyser from "../visualizer/AudioAnalyzer";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import { uid } from '@ht/shared/methods';
import MobilePhoneIcon from "@ht/shared/fonts/deos-pis/mobilephone";
import OfficeIcon from "@ht/shared/fonts/deos-pis/office-building";
import Home2Icon from "@ht/shared/fonts/deos-pis/home2";
import HoldIcon from "@ht/shared/fonts/deos-pis/pause";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
import FooterCallControl from "./footer-callcontrol";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../../utils/encryption";

declare global {
    interface Window {
        IVLConnect(a: string, b: string): void;
        setTURN(_customTURN: string, _customTURNUserName: string, _customTURNPassword: string): void;
        IVLDisconnect(): void;
        NotifyReactCallHangup(isClean: boolean): void;
        NotifyReactAppMessage(message: string): void;
        NotifyRemoteAudioChanged(): void;
        mute(): void;
        ivlRemoteAudio: HTMLAudioElement;
        conference: any;
    }
}
interface IProps {
    handleChangeRoomStatus(status: string): void;
    mediaServerUrl: string;
}
const CallControl: FC<IProps> = ({ handleChangeRoomStatus, mediaServerUrl }) => {
    const dispatch = useAppDispatch();
    const { incomingMessage, callState, uniqueDeviceId } = useAppSelector((state) => state.call);
    const { user } = useAppSelector((state) => state.auth);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);
    const wsdashurl = mediaServerUrl;
    // console.log("media server url", wsdashurl)
    const navigate = useNavigate()
    const callnotifWidth = 400;
    const locationX = floatingLocation.x === 0 ? (screen.width - callnotifWidth) / 2 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 2 : floatingLocation.y
    const { ref, x, y, isDragging } = useDragging(locationX, locationY, 400, 104);
    const [isMute, setIsMute] = useState(callState.isMute ? callState.isMute : false);
    const [isHold, setIsHold] = useState(callState.isHold ? callState.isHold : false);
    const [audio, setAudio] = useState<MediaStream>()
    const { sendRequest } = useHttpRequest();
    const resetIncomingCall = () => {

        dispatch(callIncomingMessageReceived({} as IIncomingMessage));
        dispatch(callStateChanged({} as ICallState));
        console.log("clearing callsetate")
    }
    let timer: number;
    const [duration, setDuration] = useState(callState.duration > 0 ? callState.duration : 0);
    const [intervalId, setIntervalId] = useState(0);
    const [showAudioFX, setShowAudioFX] = useState(false)
    const [micBlocked, setMicBlocked] = useState(false)
    const [allowHangup, setAllowHangup] = useState(false)

    addEventListener("microphonePermissionEvent", () => setMicBlocked(true))


    const startTimer = () => {
        timer = window.setInterval(() => {
            setDuration(dur => dur + 1);

        }, 1000);
        setIntervalId(timer);
    };
    const stopTimer = () => {
        window.clearInterval(intervalId);
    }
    useEffect(() => {
        if (duration > 5 && !allowHangup) setAllowHangup(true)
    }, [duration])
    useEffect(() => {

        if (!user)
            return;
        if (String(process.env.REACT_APP_CUSTOM_TURN) != "")
            window.setTURN(String(process.env.REACT_APP_CUSTOM_TURN), String(process.env.REACT_APP_CUSTOM_TURN_USERNAME), String(process.env.REACT_APP_CUSTOM_TURN_PASSWORD));
        if (callState.callType === "outgoing") {
            const usrid = user.userId;
            const tenantid = user.tenantId;

            const dst = callState.callDestination;
            startTimer();
            window.IVLConnect(wsdashurl, `OUTGOINGSIP_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${callState.sessionId}`);
        }
        if (callState.callType === "incoming") {
            setShowAudioFX(true)
            setAllowHangup(true)
            startTimer();
        }
        else if (callState.callType === "outgoingagent") {
            const usrid = user.userId;
            const tenantid = user.tenantId;

            const dst = callState.callDestination;
            startTimer();
            window.IVLConnect(wsdashurl, `OUTGOINGAGENT_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${callState.sessionId}`);
        }
        else if (callState.callType === "silent") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);
            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            console.log("SILENTO", callState)
            window.IVLConnect(url.href, `SILENT_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);
        }
        else if (callState.callType === "coaching") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);
            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            window.IVLConnect(url.href, `COACHING_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);

        }
        else if (callState.callType === "bargein") {
            setShowAudioFX(true)
            setAllowHangup(true)
            const usrid = user.userId;
            const tenantid = user.tenantId;
            const sessionid = uid(21)

            const dst = callState.callDestination;
            let url = new URL(wsdashurl);

            if (callState.domain) {
                url = new URL(`${callState.domain.replace("http", "ws")}:1338`);
            }
            startTimer();
            window.IVLConnect(url.href, `BARGEIN_${uniqueDeviceId}_${usrid}_${dst}_${tenantid}_${sessionid}`);

        } else if (callState.duration > 0) {
            startTimer();
        }

    }, [user])

    const setIsCalling = (val: boolean) => {
        const cstate = { ...callState };
        cstate.isCalling = val;
        dispatch(callStateChanged(cstate));
    }

    const toHHMMSS = (dur: number) => {
        const hours = Math.floor(dur / 3600);
        const minutes = Math.floor((dur - (hours * 3600)) / 60);
        const seconds = dur - (hours * 3600) - (minutes * 60);
        let strhours = hours.toString();
        let strminutes = minutes.toString();
        let strseconds = seconds.toString();

        if (hours < 10) { strhours = "0" + hours.toString(); }
        if (minutes < 10) { strminutes = "0" + minutes.toString(); }
        if (seconds < 10) { strseconds = "0" + seconds.toString(); }
        return strhours + ':' + strminutes + ':' + strseconds;
    }
    const muteCall = () => {
        setIsMute(!isMute);
        window.mute();
    }
    const sendHoldCall = async (hold: boolean) => {
        const baseUrl = String(process.env.REACT_APP_CALLNOTIFICATION_SERVICE);
        const payload = { call_id: incomingMessage.call_id, hold, tenant_id: user?.tenantId, service_group_id: incomingMessage.service_group_id }

        await sendRequest({
            baseUrl: baseUrl,
            url: `callnotification/holdcall`,
            method: "post",
            body: payload
        });
    }
    const holdCall = () => {
        setIsHold(!isHold);
        sendHoldCall(!isHold).catch(() => { })
    }
    const hangupCall = () => {
        stopTimer();
        handleChangeRoomStatus("close");
        window.IVLDisconnect();
        if (callState.callType === "silent" || callState.callType === "coaching" || callState.callType === "bargein")
            dispatch(callSendMessage({ content: JSON.stringify({ type: "hangup", callType: callState.callType, callId: callState.callDestination }) }));
        if (callState.callType === "incoming") {
            dispatch(setOnCall("ACW"));
        }
        else
            dispatch(setOnCall(""));
        setTimeout(() => {
            setIsCalling(false);
            resetIncomingCall();
        }, 2000);
    }
    useEffect(() => {
        if (micBlocked) {
            hangupCall()
            resetIncomingCall()
        }
    }, [micBlocked])

    let retryCount = 0
    window.NotifyReactCallHangup = (isClean: boolean) => {
        if (!user)
            return;

        console.log(new Date().toLocaleString(), "Hangup Triggered from IVL. DURATION:", duration, callState, "RETRY:", retryCount)
        if (duration < 1 && retryCount < 2 && !isClean && callState.callType == "incoming" && incomingMessage.call_id !== undefined) {
            console.log("receiving connection disconnected as soon as sending idle call, retrying...")
            window.IVLConnect(wsdashurl, `IDLE_${user.deviceId}_${user.userId}_${incomingMessage.call_id}_${user.tenantId}`);
            setDuration(0)
            retryCount++;
            console.log("retry count:", retryCount)
        }
        else if (duration < 1 && retryCount < 2 && !isClean && callState.callType == "outgoing" && callState.callDestination !== undefined) {
            console.log("receiving connection disconnected as soon as sending outgoing call, retrying...")
            window.IVLConnect(wsdashurl, `OUTGOINGSIP_${uniqueDeviceId}_${user.userId}_${callState.callDestination}_${user.tenantId}_${callState.sessionId}`);
            setDuration(0)
            retryCount++;
            console.log("retry count:", retryCount)
        } else {
            hangupCall();
        }

    }

    window.NotifyRemoteAudioChanged = () => {
        const RemoteAudio = window.ivlRemoteAudio.srcObject as MediaStream
        setAudio(RemoteAudio)

        console.log("ivlremoteaudio", window.ivlRemoteAudio)
    }
    window.NotifyReactAppMessage = (message) => {
        console.log("react app message", message)
        const appdata = message;
        if (appdata === 'CallAnswered') {
            setDuration(0);
            setShowAudioFX(true)

        }
    }
    useEffect(() => {
        const RemoteAudio = window.ivlRemoteAudio.srcObject as MediaStream
        setAudio(RemoteAudio)
    }, [])
    useEffect(() => {
        if (incomingMessage.msg_type && incomingMessage.msg_type.toLowerCase() == "canceledcall") {
            hangupCall();
        }
    }, [incomingMessage])
    const loadIcon = (phone_type: string) => {

        if (phone_type.toLowerCase().includes("mobile"))
            return <MobilePhoneIcon className="w-[16px] h-[16px] text-primary" />
        else if (phone_type.toLowerCase().includes("office"))
            return <OfficeIcon className="w-[16px] h-[16px] text-primary" />
        else if (phone_type.toLowerCase().includes("home"))
            return <Home2Icon className="w-[16px] h-[16px] text-primary" />
    }
    const splitCallDesc = callState?.callDescription?.split(",").length > 0 ? callState?.callDescription?.split(",") : ["", ""]
    const phonetype = splitCallDesc[0]
    const phonelabel = splitCallDesc[1]
    const description = callState.callDescription ? callState.callDescription.replace(`${phonetype},${phonelabel},`, "") : ""
    const iconPhone = loadIcon(phonetype)
    const isShowChatRoomButton = (incomingMessage.service_group_id ?? 0) == 0 && incomingMessage.msg_type == "INCOMINGCALL"
    const handleChatRoomButton = () => {
            navigate(`/leads/${encrypt(incomingMessage.session_id)}`)
    }
    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx(" draggable fixed z-[20] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                { "hidden": !overlay }
            )}>
            </div>
            <div
                ref={ref}
                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    { "bg-geyser": isDragging },
                    { "bg-white": !isDragging },
                    "draggable w-[400px] rounded-lg absolute shadow-sm bg-white z-[21] overflow-hidden min-h-[114px] p-[16px]"
                )}>

                <div className="flex flex-col justify-between items-center">

                    <div className="draggable bg-white rounded-lg text-md self-start flex flex-row">
                        <div className="draggable rounded-lg ml-[8px]">
                            <div className="draggable flex flex-col gap-[8px] items-start leading-4">
                                <span className="text-base text-grey-200 cursor-default">Audio Call {toHHMMSS(duration)}</span>
                                <span className="font-semibold text-black text-lg cursor-default">{description}</span>
                                <span className="font-semibold text-primary text-base cursor-default flex flex-row gap-2">{iconPhone}{phonelabel}</span>
                                <div className="flex flex-row">
                                    {showAudioFX && audio ?

                                        <AudioAnalyser audio={audio}></AudioAnalyser>
                                        :
                                        <span className="font-semibold text-gray-700">Calling...</span>
                                    }
                                    <div id="meeting-gallery" /*style={{ height: "calc(100vh - 80px)" }}*/>
                                        {(


                                            <div className={clsx("draggable absolute p-[16px] top-[0px] right-[0px] flex flex-col items-center w-[160px]")}>
                                                <div className={clsx("draggable rounded-md bg-white h-[52px] py-[8px] pl-0 pr-[32px] gap-[8px] flex flex-col items-end")}>

                                                    <div className="flex flex-row-reverse justify-end gap-[12px] items-center">
                                                        <Button shape="ellipse" disabled={!allowHangup} onClick={hangupCall} type="button" variant="contained" color={allowHangup ? "danger" : "light"} iconButton className="w-[32px] h-[32px]">
                                                            <HangupIcon className={clsx("w-[20px] h-[20px]", { "text-gray-700": !allowHangup }, { "text-white": allowHangup })} />
                                                        </Button>
                                                        <Button shape="ellipse" onClick={muteCall} type="button" variant="contained" color={isMute ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                            {
                                                                isMute ?
                                                                    <MuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                                    : <UnmuteIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />

                                                            }
                                                        </Button>
                                                        <Button shape="ellipse" onClick={holdCall} type="button" variant="contained" color={isHold ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                            <HoldIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                        </Button>
                                                        {isShowChatRoomButton &&
                                                            <Button shape="ellipse" onClick={handleChatRoomButton} type="button" variant="contained" color={isHold ? "primary" : "light"} iconButton className="w-[32px] h-[32px]">
                                                                <ChatIcon className={clsx("w-[20px] h-[20px] text-grey-200")} />
                                                            </Button>
                                                        }

                                                    </div>
                                                    {callState.serviceGroupImage &&
                                                        <div className="w-[40px] h-[40px] flex flex-row justify-center align-center">
                                                            <img src={callState.serviceGroupImage} role="presentation"
                                                                className="object-contain w-fit max-w-56 max-h-32 rounded-lg" alt="" />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <FooterCallControl />

                </div>
            </div>
        </>

    );
};

export default CallControl;